<div class="row card-deck"    [@routerTransition]>
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
    <div class="card-body">
      <div>
        <div id="advanced-form" action="#">
          <!-- step-1 -->
          <h3><span class="s-title"><span class="xs-hide">Skills</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>

          <fieldset>
            <div>
              <legend>Skills Update</legend>

              <div *ngIf='IsShowActorFormList'>


                <div class="row">
                  <div class="col-sm-12">
                    <div class="card-content">
                      <div class="panel-heading">
                        <div class="row">
                          <div class="col-12">
                            <h6 class="panel-title fb">
                              Skill Assessment Sheets

                              <button type="button" (click)="openNewContent()" class="btn btn-primary btn-sm"><i class="fas fa-plus"></i></button>
                            </h6>
                            <div class="table-component">
                              <div class="table-responsive">
                                <table class="table table-striped">
                                  <thead>
                                    <tr>
                                      <th scope="col">Skill Category</th>
                                      <th scope="col">Created At</th>
                                      <th scope="col">Score </th>
                                      <th scope="col">Score %</th>
                                      <th scope="col">Action</th>

                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let l of CurrentFdActorReportsDocController">
                                      <td>{{l.TemplateName}}</td>
                                      <td>{{l.Date | date:'dd-MMM-yyyy'}}</td>
                                      <td>{{l.ResultScoreCard}}/{{l.TotalTemplateScore}}</td>
                                      <td>{{l.ScorePercent}}</td>

                                      <td>

                                        <a (click)="del_(l.ActorReportCode)"><i class="far fa-trash-alt  nav-link-hand"></i></a>

                                      </td>
                                    </tr>

                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <h3><span class="s-title"><span class="xs-hide">Skills Update</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>

          <fieldset>
            <div>
              <legend>Skills List</legend>

 
              <div class="card skillassest">
                <div class="card-header wh-header"><span>Skill Assessment</span>   <button type="button" (click)="openNewContent()" class="btn btn-primary btn-sm"><i class="fas fa-plus"></i></button></div>
                <div class="card-body search-body">
                  <div class="row search-box">
                    <div class="col-md-2"><span class="pink-round-broder"><img src="../../../../../../../../wwwroot/healins-assets/images/admin/skillsassessment.png"></span></div>
                    <div class="col-md-8">

                      <div class="row">

                        <div class="form-group col-md-6 col-xs-12">
                          <label for="fitnessType">Nursing Skills Category</label>

                          <select class="form-control" id="ActorReportCode"
                                  name="ActorReportCode" [(ngModel)]="ActorReportCode"
                                  (change)="onChangeTemplate($event.target.value)"
                                  required>

                            <option selected="" value="0"></option>
                            <option *ngFor="let R of CurrentFdActorReportsDocController" [value]="R.ActorReportCode">
                              {{R.TemplateName}}
                            </option>


                          </select>
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                          <label for="issuingAuthority">Select Sub Division</label>

                          <select class="form-control" id="SectionCode"
                                  name="SectionCode" [(ngModel)]="SectionCode"
                                  (change)="onChangeSectionCode($event.target.value)"
                                  required>

                            <option selected="" value="0"></option>
                            <option *ngFor="let R of CurrentFdSectionsController" [value]="R.SectionCode">
                              {{R.SectionTitle}}
                            </option>


                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2"></div>
                  </div>

                  <div class="card-content" *ngIf="SectionCode>0 && ActorReportCode >0 && IsRateing">
                    <div class="panel-heading">
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <div class="bc-icons-2">
                            <ol class="breadcrumb">
                              <li>Nursing Skills: &nbsp;</li>
                              <li class="breadcrumb-item"> {{TemplateName}}<i class="fa fa-angle-right mx-2" aria-hidden="true"></i></li>
                              <li class="breadcrumb-item active">{{SectionName}}</li>
                            </ol>
                          </div>
                          <h3 class="panel-title"></h3>
                        </div>
                        <div class="col-12 col-md-6 text-right ">
                          <ul class="nav navbar-nav">
                            <li class="dropdown">
                              <a href="#" class="dropdown-toggle" data-toggle="dropdown">Rating Info <span class="glyphicon glyphicon-user pull-right"></span></a>
                              <ul class="dropdown-menu">
                                <li><a href="#"><span>0</span> Not Applicable </a></li>
                                <li><a href="#"><span>1</span> No Experience </a></li>
                                <li><a href="#"><span>2</span> Some Expericence (Require Assistance) </a></li>
                                <li><a href="#"><span>3</span> Intermittent Experience (May Require Assistance) </a></li>
                                <li><a href="#"><span>4</span> Experienced (Performs without Assistance) </a></li>
                                <li><a href="#"><span>5</span> Very Experienced (Able to Teach/Supervise) </a></li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="CurrentFdActorDocReportDetailsController">
                      <div class="table-responsive product-chart-wrapper ps" data-ps-id="2456">
                        <div class="rTable">


                          <div class="rTableRow" *ngFor="let c of CurrentFdActorDocReportDetailsController; let i = index" [ngSwitch]="c.ValueType">
                            <div class="rTableCell">{{c.AttributeName}}</div>

                            <div class="rTableCell" *ngSwitchCase="'CsvList'">

                              <div class="form-check form-check-inline" *ngFor="let cc of c.ValueSource | splitpipe:','">
                                <label class="form-check-label">

                                  <input class="form-check-input" type="radio" value="{{cc}}" name="{{i}}"
                                         [(ngModel)]="c.ValueData"
                                         placeholder="Value" checked="checked">  {{cc}}
                                  <i class="input-helper"></i>
                                </label>
                              </div>


                            </div>




                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-right" *ngIf="CurrentFdActorDocReportDetailsController.length >0 && SectionCode>0 && ActorReportCode >0  && IsRateing">
                  <button type="submit" class="btn actions-btn-prime" (click)="SaveFDActorDocReportDetails()" *ngIf='!isRequesting'>Save</button>
                </div>
                <div class="card-content" *ngIf="CurrentFdActorDocReportDetailsController.length >0 && SectionCode>0 && ActorReportCode >0  && !IsRateing">
                  <h1> Template is Not Supporting</h1>
                </div>

              </div>
            </div>
          </fieldset>
        </div>
        </div>
    </div>
    </div>
  </div>
